import { PillButton } from "@/components/Button/PillButton";
import { AddSvg } from "@/components/Icon/Icon";
import { EditTemplateModal } from "@/pages/Home/DesignSection/AssembledTabsSection/EditTemplateModal/EditTemplateModal";
import { defaultTemplate, setTemplate } from "@/store/slices/templateSlice";
import { store } from "@/store/store";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const CreateTemplateButton = () => {
  const { t } = useTranslation();
  const [openEditTemplateModal, setOpenEditTemplateModal] = useState(false);

  const handleAddTemplate = () => {
    setOpenEditTemplateModal(true);
    store.dispatch(setTemplate({ ...defaultTemplate }));
  };

  return (
    <>
      <PillButton startIcon={<AddSvg color="inherit" />} variant="contained" color="secondary" onClick={handleAddTemplate}>
        {t("common:links.create")}
      </PillButton>
      <EditTemplateModal open={openEditTemplateModal} setOpen={setOpenEditTemplateModal} action={"add"} />
    </>
  );
};
